export default __webpack_public_path__ + "static/media/Terms-&-Conditions.91c7ec34.jpg";